import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="app">
      <div className="app-main">
        <div className="stage-container">
          <div className="stage-header">
            <h1>Privacy Policy</h1>
            <p>Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div style={{ textAlign: 'left', lineHeight: '1.6' }}>
            <h2>1. Information We Collect</h2>
            <h3>1.1 Information You Provide</h3>
            <p>When you use Race Series Points Manager, we may collect:</p>
            <ul>
              <li><strong>Account Information:</strong> When you sign in with Google, we collect your email address, name, and profile information to create your account.</li>
              <li><strong>Racing Data:</strong> Race results, participant information, and series data that you upload and manage through our platform.</li>
              <li><strong>Usage Data:</strong> Information about how you use our service, including features accessed and actions taken.</li>
            </ul>

            <h3>1.2 Information from Third Parties</h3>
            <p>When you connect your Google account:</p>
            <ul>
              <li><strong>Google:</strong> We receive your basic profile information (name, email) as permitted by Google's OAuth policies.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and maintain the Race Series Points Manager service</li>
              <li>Authenticate your identity and secure your account</li>
              <li>Store and manage your racing series data</li>
              <li>Generate and publish race results as directed by you</li>
              <li>Communicate with you about service updates or issues</li>
              <li>Improve our service and develop new features</li>
            </ul>

            <h2>3. Data Storage and Security</h2>
            <p>Your data is stored securely using Amazon Web Services (AWS) infrastructure:</p>
            <ul>
              <li><strong>Personal Data:</strong> Stored in private, encrypted folders accessible only to your account</li>
              <li><strong>Racing Data:</strong> Stored in secure AWS S3 buckets with access controls</li>
              <li><strong>Authentication:</strong> Managed through AWS Cognito with industry-standard security</li>
              <li><strong>Published Results:</strong> Made public only when you explicitly choose to publish them</li>
            </ul>

            <h2>4. Data Sharing and Disclosure</h2>
            <p>We do not sell, trade, or rent your personal information. We may share data only:</p>
            <ul>
              <li><strong>With Your Consent:</strong> When you explicitly choose to publish race results</li>
              <li><strong>Service Providers:</strong> With AWS and other service providers necessary to operate our platform</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and users' safety</li>
            </ul>

            <h2>5. Your Rights and Controls</h2>
            <p>You have the right to:</p>
            <ul>
              <li><strong>Access:</strong> View and download all data associated with your account</li>
              <li><strong>Modify:</strong> Edit or update your racing series data at any time</li>
              <li><strong>Delete:</strong> Request deletion of your account and associated data</li>
              <li><strong>Export:</strong> Download your racing data in CSV format</li>
              <li><strong>Control Publishing:</strong> Choose what information to make public in race results</li>
            </ul>



            <h2>6. Data Deletion</h2>
            <p>You can request data deletion through our <a href="/data-deletion" style={{ color: '#2780E3' }}>Data Deletion Request</a> page:</p>
            <ul>
              <li><strong>Complete Account:</strong> Delete all data including racing series and published results</li>
              <li><strong>Processing Time:</strong> Deletion requests are processed within 30 days</li>
            </ul>

            <h2>7. Children's Privacy</h2>
            <p>Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.</p>

            <h2>8. International Data Transfers</h2>
            <p>Your data may be stored and processed in the United States through our AWS infrastructure. By using our service, you consent to the transfer of your data to the United States.</p>

            <h2>9. Changes to Privacy Policy</h2>
            <p>We may update this Privacy Policy periodically. We will notify users of significant changes through our platform or by email. Continued use of the service after changes constitutes acceptance of the updated policy.</p>

            <h2>10. Contact Information</h2>
            <p>For questions about this Privacy Policy or your data, contact us at:</p>
            <ul>
              <li><strong>Email:</strong> privacy@seriespoints.zone4.xyz</li>
              <li><strong>Data Deletion:</strong> <a href="/data-deletion" style={{ color: '#2780E3' }}>Data Deletion Request Form</a></li>
            </ul>

            <hr style={{ margin: '2rem 0', border: '1px solid #e2e8f0' }} />
            <p style={{ fontSize: '0.9rem', color: '#718096' }}>
              This Privacy Policy complies with applicable data protection laws including GDPR and CCPA requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 